import { dequal } from "dequal/lite"
import transform from "lodash-es/transform"

export const removeUndefinedKeys = <T extends object>(value: T): Partial<T> | undefined => {
	if (typeof value !== "object" || value === undefined || value === null) {
		throw new Error(`removeUndefinedKeys needs an object to operate, got ${typeof value}`)
	}

	const result = transform(value, (acc: T, val, key) => {
		if (val === undefined) {
			return acc
		}

		if (typeof val !== "object" || val === null) {
			acc[key] = val
			return acc
		}

		const removed: any = removeUndefinedKeys(val as unknown as object)
		if (removed !== undefined) {
			acc[key] = removed
		}

		return acc
	})

	return dequal(result, {}) ? undefined : result
}
